<template>
  <img src="./assets/logo.png">
  <DiscountForm/>
</template>

<script>
import DiscountForm from "@/components/DiscountForm";

export default {
  name: 'App',
  components: {
    DiscountForm
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
